module.exports = __webpack_public_path__ + "img/security.2ab461d4.webp";